import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebaseconfig';
import { collection, getDocs } from 'firebase/firestore';
import '../css/login.css';

const LoginPage = ({ onLogin }) => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [userMap, setUserMap] = useState({});

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const usersCollection = collection(db, 'users');
      const userSnapshot = await getDocs(usersCollection);
      const userMap = {};
      userSnapshot.forEach(doc => {
        const userData = doc.data();
        const email = userData.email;
        const user = userData.user;
        
        // Almacenar email y usuario exactamente como están en la base de datos
        userMap[email] = { email, user };
        userMap[user] = { email, user };
        
        // Almacenar versión en minúsculas para búsqueda eficiente
        userMap[email.toLowerCase()] = { email, user };
        userMap[user.toLowerCase()] = { email, user };
      });
      setUserMap(userMap);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError("Error al cargar usuarios. Por favor, intente más tarde.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!identifier || !password) {
      setError('Por favor, rellena todos los campos');
      return;
    }

    // Buscar el usuario en el mapa
    const lowercaseIdentifier = identifier.toLowerCase();
    const userInfo = userMap[lowercaseIdentifier];

    if (!userInfo || (userInfo.user !== identifier && userInfo.email !== identifier)) {
      setError("Usuario no encontrado o contraseña incorrecta.");
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, userInfo.email, password);
      console.log("Login exitoso:", userCredential.user);
      onLogin(userCredential.user);
    } catch (error) {
      console.error("Error en el inicio de sesión:", error.message);
      setError("Error al iniciar sesión: Verifique su usuario o contraseña.");
    }
  };

  return (
    <div className="container-login">
      <div class="wrap-login"> 
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="img">
          <img src="encabezado.png" alt="logo municipalidad" className="imglogo"/>
        </div>
        <div className="form-header">
          <h1 className='login-form-title'>Inicia sesión para continuar</h1>
        </div>

        <div className="wrap-input100">
          <label htmlFor="identifier" className='login-label'>Nombre de usuario o correo electrónico</label>
          <input
            id="identifier"
            class='input100'
            type="text"
            name="txtUsuario"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="Ingrese su nombre de usuario o correo"
          />
          <span class="focus-efecto"></span> 
        </div>

        <div className="wrap-input100">
          <label htmlFor="password" className='login-label'>Contraseña</label>
          <input
            class="input100"
            id="password"
            type="password"
            name="txtPassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Ingrese su contraseña"
          />
          <span class="focus-efecto"></span>
        </div>

        {error && <div className="error">{error}</div>}
        <div className="container-login-form-btn">
          <div className="wrap-login-form-btn"> 
            <div className="login-form-bgbtn"></div> 
              <button type="login" name="btnEntrar" className="login-form-btn">
                Iniciar sesión
              </button>
          </div> 
        </div>
      </form>
      </div> 
    </div>
  );
};

export default LoginPage;